import BaseModel from './BaseModel';

class Pincode extends BaseModel {
  constructor(data = {}, useCase) {
    super(data);
    switch(useCase) {
      case 0:
        this.set_api_data(data);
        break;
      default:
        this.updateData(data);
        break;
    }
  }

  set_api_data = (data) => {
    this.id = data.id || "";
    this.code = data.pincode || "";
    this.area = data.area || "";
    this.city = data.city || "";
    this.cluster = data.cluster || {};
    this.dist = data.district || {};
    this.state = data.state || {};
    this.branch = data.circle || {};
  }

  updateData = (data) => {
    this.id = data.id || "";
    this.area = data.area || "";
    this.city = data.city || "";
    this.cluster = data.cluster || {};
    this.code = data.code || "";
    this.dist = data.dist || {};
    this.state = data.state || {};
    this.branch = data.branch || {};
  }

  toApiJson = (single = false) => {
    this.completeValidation();
    if(single){
      return {
        id: this.id,
        pincode: {
          id: this.id,
          area: this.area,
          city: this.city,
          cluster_id: this.cluster.id,
          code: this.code,
          district_id: this.dist.id,
          branch_id: this.branch.id,
          state: this.state.name
        }
      }
    }

    return {
        pincodes: [{
          id: this.id,
          area: this.area,
          city: this.city,
          cluster_id: this.cluster.id,
          code: this.code,
          dist: this.dist.name,
          state: this.state.name
      }]
    }
  }

  validations = (field) => {
    return {
      area: () => {
        if(this[field] === "") {
          this.errors.area = "This field is required and cannot be empty.";
        } else {
          delete this.errors.area;
        }
      },
      city: () => {
        if(this[field] === "") {
          this.errors.city = "This field is required and cannot be empty.";
        } else {
          delete this.errors.city;
        }
      },
      cluster: () => {
        if(Object.keys(this[field]).length <= 0) {
          this.errors.cluster = "This field is required and cannot be empty.";
        } else {
          delete this.errors.cluster;
        }
      },
      code: () => {
        if(this[field] === "") {
          this.errors.code = "This field is required and cannot be empty.";
        } else if(this[field].search(/^\d{6}$/) === -1) {
          this.errors.code = "Enter valid pincode.";
        } else {
          delete this.errors.code;
        }
      },
      dist: () => {
        if(Object.keys(this[field]).length <= 0) {
          this.errors.dist = "This field is required and cannot be empty.";
        } else {
          delete this.errors.dist;
        }
      },
      state: () => {
        if(Object.keys(this[field]).length <= 0) {
          this.errors.state = "This field is required and cannot be empty.";
        } else {
          delete this.errors.state;
        }
      },
      branch: () => {
        if(Object.keys(this[field]).length <= 0) {
          this.errors.branch = "This field is required and cannot be empty.";
        } else {
          delete this.errors.branch;
        }
      },
    }[field];
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default Pincode;
